import * as React from "react";
import SingleCouncil from "./SingleCouncil";
import { connect } from "react-redux";
import { defaultYear } from "src/constants/ApiSettings";
import { IConnectedModuleProps, IConnectedModuleState } from "src/interfaces";
import SectionHeading from "src/components/general/SectionHeading";

class SizeOf extends React.PureComponent<
  IConnectedModuleProps,
  IConnectedModuleState
> {
  constructor(props: IConnectedModuleProps) {
    super(props);

    const selectedYear = this.props.defaultYear
      ? this.props.defaultYear
      : defaultYear;

    this.state = { selectedYear };
  }

  public handleYearChange = (value: string) => {
    this.setState({ selectedYear: value });
  };

  public render() {
    return (
      <div className="flex flex-wrap items-center justify-center content-center w-full" id="size">
        <SectionHeading
          heading="Size of your council area"
          alignment="left"
          learnMore={ "totalArea" }
          year={ this.state.selectedYear }
          councilSays={ "totalAreaCouncilSays" }
          inverse={ true }
        />
        <h3 className="w-full mt-4">Area</h3>
        {this.props.councils.map((council, index) => (
          <div 
            key={index}
            className="w-full sm:w-1/2 md:w-1/2 lg:w-1/4 items-center justify-center content-center mb-5">
              <SingleCouncil
                ordinal={index + 1}
                council={council}
                year={this.state.selectedYear}
                // residents={65000}
                // area={2500}
                // ordinal={1}
                // map={"PAROO SHIRE.svg"}
              />
          </div>
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  defaultYear:
    state.selectables.years.length > 0 ? state.selectables.years[0] : null,
  councils: state.selected.councils,
  
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SizeOf);



// WEBPACK FOOTER //
// ./src/components/report/councilArea/SizeOf/index.tsx